var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnPrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FCB03B78-A97C-4C8C-8B00-DE6FFD56B8AF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coach-Mvp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Messages-&-Notification-Copy",
    transform: "translate(-1674.000000, -215.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1656.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_privacy_policy",
    transform: "translate(18.926407, 139.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.257732,16 C12.1958763,16 13,15.3043478 13,14.3557312 L13,8.03162055 C13,7.14624506 12.2628866,6.45059289 11.3917526,6.45059289 L11.3917526,4.61660079 C11.3917526,2.08695652 9.18041237,0 6.5,0 C3.81958763,0 1.60824742,2.08695652 1.60824742,4.61660079 L1.60824742,6.45059289 C0.737113402,6.51383399 0,7.20948617 0,8.03162055 L0,14.3557312 C0,15.2411067 0.737113402,16 1.74226804,16 L11.257732,16 Z M7.84020619,12.2055336 C7.84020619,12.9011858 7.2371134,13.5335968 6.5,13.5335968 C5.7628866,13.5335968 5.15979381,12.9644269 5.15979381,12.2055336 L5.15979381,10.1818182 C5.15979381,9.48616601 5.7628866,8.85375494 6.5,8.85375494 C7.2371134,8.85375494 7.84020619,9.4229249 7.84020619,10.1818182 L7.84020619,12.2055336 Z M8.37628866,4.61660079 L8.37628866,6.38735178 L6.5,6.38735178 L4.62371134,6.38735178 L4.62371134,4.61660079 L4.62371134,4.61660079 C4.62371134,4.23715415 4.62371134,3.85770751 4.75773196,3.54150198 C4.75773196,3.47826087 4.75773196,3.47826087 4.82474227,3.41501976 C4.82474227,3.35177866 4.82474227,3.28853755 4.89175258,3.28853755 C4.95876289,3.16205534 4.95876289,3.09881423 5.0257732,3.03557312 C5.0257732,3.03557312 5.0257732,3.03557312 5.0257732,2.97233202 C5.36082474,2.46640316 5.89690722,2.08695652 6.56701031,2.08695652 C7.2371134,2.15019763 7.77319588,2.46640316 8.10824742,2.97233202 C8.10824742,2.97233202 8.10824742,2.97233202 8.10824742,3.03557312 C8.17525773,3.09881423 8.17525773,3.22529644 8.24226804,3.28853755 C8.24226804,3.35177866 8.24226804,3.41501976 8.30927835,3.41501976 C8.30927835,3.47826087 8.30927835,3.47826087 8.37628866,3.54150198 C8.30927835,3.85770751 8.37628866,4.23715415 8.37628866,4.61660079 L8.37628866,4.61660079 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPrivacyPolicy);
export default __webpack_public_path__ + "static/media/icn_privacy_policy.2364fb5575b8ff9b8b8479a5586fcf9a.svg";
export { ForwardRef as ReactComponent };